import { render, staticRenderFns } from "./AddMoreFilesButtons.vue?vue&type=template&id=65a843d2&scoped=true"
import script from "./AddMoreFilesButtons.vue?vue&type=script&lang=js"
export * from "./AddMoreFilesButtons.vue?vue&type=script&lang=js"
import style0 from "./AddMoreFilesButtons.vue?vue&type=style&index=0&id=65a843d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a843d2",
  null
  
)

export default component.exports